module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAABTklEQVRYhe2X320CMQzGPyoGYINjBDYANmgnaN88RmEMP5UR2gkKG7Qb0A3oBFdFPSQT2wm6XnRUyu/p8DnOh+38uUnbtrgl7m5KTRV0BVVQjqn1nojmAJ4Kzrtn5r2yeoIABEHPBQUFTEH/o2QAjgC2Bec1s4OEoFNq0AAcvRCeoHsALwUFvXVzKLweWijLsLjxxxLUENFMWRMlW4rnB2Z+VR49ICJ5tVhYfaoyRERxdj6GENPxKZ5X6q0lKCrXNzO7K6IH8s+ZbZETNGR24nimIKuHpOOciFSd/4Bs5MYKYwmSNN7AUlglGxUrQ7tua38Utty5thJbxVcXI+VzsJZ8wPzqIKIw+P38m5knyunSfyOuKwdmVks68tky80YFqlfYK6iCclirTBEdikWpJcvhlSwcguueMU/K8stObIbuDcLcGMek9lCOKigJgB8YZUYPK9wO0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_company.png
// module id = 77kW
// module chunks = 4